import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'

export const StatusBadgeTone = {
	ERROR: 'error',
	WARNING: 'warning',
	SUCCESS: 'success',
	INFORMATION: 'information',
	NEUTRAL: 'neutral',
	BRAND: 'brand'
} as const

export type StatusBadgeTone = (typeof StatusBadgeTone)[keyof typeof StatusBadgeTone]

export const StatusBadgeSize = {
	SMALL: 'small',
	MEDIUM: 'medium'
} as const

export type StatusBadgeSize = (typeof StatusBadgeSize)[keyof typeof StatusBadgeSize]

export const StatusBadgeVariant = {
	ICON: 'icon',
	TEXT: 'text',
	DOT: 'dot',
	INLINE: 'inline'
} as const

export type StatusBadgeVariant = (typeof StatusBadgeVariant)[keyof typeof StatusBadgeVariant]

export const StatusBadgeProperty = StatusBadgeVariant
export type StatusBadgeProperty = StatusBadgeVariant

type StatusBadgeToneConfig = {
	backgroundColor: string
	textColor: string
	icon: IconName
}

export const STATUS_BADGE_TONE_CONFIG = {
	[StatusBadgeTone.ERROR]: {
		backgroundColor: '#E4485B0D',
		textColor: '#E4485B',
		icon: 'failOctagonFill'
	},
	[StatusBadgeTone.WARNING]: {
		backgroundColor: '#FFC02E0D',
		textColor: '#9B7600',
		icon: 'warning'
	},
	[StatusBadgeTone.SUCCESS]: {
		backgroundColor: '#0ACC920D',
		textColor: '#067A57',
		icon: 'success'
	},
	[StatusBadgeTone.INFORMATION]: {
		backgroundColor: '#26B0FF0D',
		textColor: '#1C8BC8',
		icon: 'info'
	},
	[StatusBadgeTone.NEUTRAL]: {
		backgroundColor: '#00498011',
		textColor: '#7A8A99',
		icon: 'stars'
	},
	[StatusBadgeTone.BRAND]: {
		backgroundColor: '#007ACC0D',
		textColor: '#007ACC',
		icon: 'stars'
	}
} satisfies Record<StatusBadgeTone, StatusBadgeToneConfig>
